import { ArticleCard } from "./article-card"
import { TrendingUp } from "lucide-react"

export interface TrendingListItem {
  /** Unique key for React */
  id: string | number
  /** Item destination */
  href: string
  /** Item title (single line ideally — wraps gracefully if longer) */
  title: string
  image?: string
  authorName?: string | null
  authorImageUrl?: string | null
  publishedAt?: string | null
  excerpt?: string
}

interface TrendingListProps {
  /** List items to render. Numbered 01, 02, … in order. */
  items: TrendingListItem[]
  /**
   * Eyebrow above the list. Default `"Trending now"`.
   * Renders with the orange color + TrendingUp lucide icon.
   */
  eyebrow?: string
}

/** Ordered editorial selection, presented through the shared article card. */
export function TrendingList({ items, eyebrow = "Trending now" }: TrendingListProps) {
  if (!items || items.length === 0) return null
  return (
    <div
      style={{
        background: "#fff",
        border: "1px solid var(--gray-200)",
        borderRadius: 12,
        padding: 20,
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 6,
          fontSize: 11,
          fontWeight: 800,
          letterSpacing: "0.18em",
          textTransform: "uppercase",
          color: "var(--fridge-orange)",
          marginBottom: 14,
        }}
      >
        <TrendingUp className="w-3.5 h-3.5" />
        {eyebrow}
      </div>
      <ol
        style={{
          listStyle: "none",
          padding: 0,
          margin: 0,
          display: "flex",
          flexDirection: "column",
          gap: 12,
        }}
      >
        {items.map((item, i) => (
          <li key={item.id}>
            <p className="mb-2 text-xs font-bold text-[#0469f0]">{String(i + 1).padStart(2, "0")}</p>
            <ArticleCard href={item.href} title={item.title} imageUrl={item.image}
              author={item.authorName || undefined} authorImageUrl={item.authorImageUrl}
              date={item.publishedAt || undefined} excerpt={item.excerpt} badge="News" />
          </li>
        ))}
      </ol>
    </div>
  )
}
